const selectors = {
  trigger: '[data-aroundrs-blog-load-more]',
  grid: '[data-aroundrs-blog-grid]',
  card: '[data-aroundrs-blog-card]',
  root: '[data-aroundrs-blog-root]',
  wrap: '.br-load-more-wrap',
};

document.addEventListener('click', (event) => {
  const card = event.target instanceof Element ? event.target.closest(selectors.card) : null;

  if (!card || event.target.closest('a, button, input, select, textarea')) return;

  const link = card.querySelector('a[href]');

  if (link instanceof HTMLAnchorElement) {
    window.location.href = link.href;
  }
});

document.addEventListener('click', async (event) => {
  const trigger = event.target instanceof Element ? event.target.closest(selectors.trigger) : null;

  if (!(trigger instanceof HTMLAnchorElement)) return;

  event.preventDefault();

  if (trigger.getAttribute('aria-busy') === 'true') return;

  const root = trigger.closest(selectors.root) || document;
  const grid = root.querySelector(selectors.grid);

  if (!grid) {
    window.location.href = trigger.href;
    return;
  }

  const originalLabel = trigger.textContent;
  let nextUrl = trigger.href;

  trigger.setAttribute('aria-busy', 'true');
  trigger.textContent = trigger.dataset.loadingLabel || originalLabel || '';

  try {
    while (nextUrl) {
      const response = await fetch(nextUrl);

      if (!response.ok) throw new Error('Unable to load more articles');

      const html = await response.text();
      const nextDocument = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = nextDocument.querySelector(selectors.grid);

      if (!nextGrid) break;

      nextGrid.querySelectorAll(selectors.card).forEach((card) => {
        grid.append(card);
      });

      const nextTrigger = nextDocument.querySelector(selectors.trigger);
      nextUrl = nextTrigger instanceof HTMLAnchorElement ? nextTrigger.href : '';
    }

    trigger.closest(selectors.wrap)?.remove();
  } catch (error) {
    window.location.href = trigger.href;
  } finally {
    trigger.removeAttribute('aria-busy');

    if (trigger.isConnected) {
      trigger.textContent = originalLabel || '';
    }
  }
});
